// source: Reflection.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

import jspb, { Message, BinaryReader, BinaryWriter } from "google-protobuf";
var goog = jspb;
var global =
  (typeof globalThis !== "undefined" && globalThis) ||
  (typeof window !== "undefined" && window) ||
  (typeof global !== "undefined" && global) ||
  (typeof self !== "undefined" && self) ||
  function () {
    return this;
  }.call(null) ||
  Function("return this")();

goog.exportSymbol("proto.grpc.reflection.v1.ErrorResponse", null, global);
goog.exportSymbol(
  "proto.grpc.reflection.v1.ExtensionNumberResponse",
  null,
  global
);
goog.exportSymbol("proto.grpc.reflection.v1.ExtensionRequest", null, global);
goog.exportSymbol(
  "proto.grpc.reflection.v1.FileDescriptorResponse",
  null,
  global
);
goog.exportSymbol("proto.grpc.reflection.v1.ListServiceResponse", null, global);
goog.exportSymbol(
  "proto.grpc.reflection.v1.ServerReflectionRequest",
  null,
  global
);
goog.exportSymbol(
  "proto.grpc.reflection.v1.ServerReflectionRequest.MessageRequestCase",
  null,
  global
);
goog.exportSymbol(
  "proto.grpc.reflection.v1.ServerReflectionResponse",
  null,
  global
);
goog.exportSymbol(
  "proto.grpc.reflection.v1.ServerReflectionResponse.MessageResponseCase",
  null,
  global
);
goog.exportSymbol("proto.grpc.reflection.v1.ServiceResponse", null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.reflection.v1.ServerReflectionRequest = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    null,
    proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_
  );
};
goog.inherits(proto.grpc.reflection.v1.ServerReflectionRequest, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.reflection.v1.ServerReflectionRequest.displayName =
    "proto.grpc.reflection.v1.ServerReflectionRequest";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.reflection.v1.ExtensionRequest = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpc.reflection.v1.ExtensionRequest, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.reflection.v1.ExtensionRequest.displayName =
    "proto.grpc.reflection.v1.ExtensionRequest";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.reflection.v1.ServerReflectionResponse = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    null,
    proto.grpc.reflection.v1.ServerReflectionResponse.oneofGroups_
  );
};
goog.inherits(proto.grpc.reflection.v1.ServerReflectionResponse, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.reflection.v1.ServerReflectionResponse.displayName =
    "proto.grpc.reflection.v1.ServerReflectionResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.reflection.v1.FileDescriptorResponse = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.grpc.reflection.v1.FileDescriptorResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.grpc.reflection.v1.FileDescriptorResponse, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.reflection.v1.FileDescriptorResponse.displayName =
    "proto.grpc.reflection.v1.FileDescriptorResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.reflection.v1.ExtensionNumberResponse = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.grpc.reflection.v1.ExtensionNumberResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.grpc.reflection.v1.ExtensionNumberResponse, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.reflection.v1.ExtensionNumberResponse.displayName =
    "proto.grpc.reflection.v1.ExtensionNumberResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.reflection.v1.ListServiceResponse = function (opt_data) {
  Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.grpc.reflection.v1.ListServiceResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.grpc.reflection.v1.ListServiceResponse, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.reflection.v1.ListServiceResponse.displayName =
    "proto.grpc.reflection.v1.ListServiceResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.reflection.v1.ServiceResponse = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpc.reflection.v1.ServiceResponse, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.reflection.v1.ServiceResponse.displayName =
    "proto.grpc.reflection.v1.ServiceResponse";
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.grpc.reflection.v1.ErrorResponse = function (opt_data) {
  Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.grpc.reflection.v1.ErrorResponse, Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.grpc.reflection.v1.ErrorResponse.displayName =
    "proto.grpc.reflection.v1.ErrorResponse";
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_ = [
  [3, 4, 5, 6, 7],
];

/**
 * @enum {number}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.MessageRequestCase = {
  MESSAGE_REQUEST_NOT_SET: 0,
  FILE_BY_FILENAME: 3,
  FILE_CONTAINING_SYMBOL: 4,
  FILE_CONTAINING_EXTENSION: 5,
  ALL_EXTENSION_NUMBERS_OF_TYPE: 6,
  LIST_SERVICES: 7,
};

/**
 * @return {proto.grpc.reflection.v1.ServerReflectionRequest.MessageRequestCase}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.getMessageRequestCase =
  function () {
    return /** @type {proto.grpc.reflection.v1.ServerReflectionRequest.MessageRequestCase} */ (
      Message.computeOneofCase(
        this,
        proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0]
      )
    );
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.grpc.reflection.v1.ServerReflectionRequest.prototype.toObject =
    function (opt_includeInstance) {
      return proto.grpc.reflection.v1.ServerReflectionRequest.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.grpc.reflection.v1.ServerReflectionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.grpc.reflection.v1.ServerReflectionRequest.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        host: Message.getFieldWithDefault(msg, 1, ""),
        fileByFilename: (f = Message.getField(msg, 3)) == null ? undefined : f,
        fileContainingSymbol:
          (f = Message.getField(msg, 4)) == null ? undefined : f,
        fileContainingExtension:
          (f = msg.getFileContainingExtension()) &&
          proto.grpc.reflection.v1.ExtensionRequest.toObject(
            includeInstance,
            f
          ),
        allExtensionNumbersOfType:
          (f = Message.getField(msg, 6)) == null ? undefined : f,
        listServices: (f = Message.getField(msg, 7)) == null ? undefined : f,
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.grpc.reflection.v1.ServerReflectionRequest();
  return proto.grpc.reflection.v1.ServerReflectionRequest.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.reflection.v1.ServerReflectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setHost(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setFileByFilename(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setFileContainingSymbol(value);
          break;
        case 5:
          var value = new proto.grpc.reflection.v1.ExtensionRequest();
          reader.readMessage(
            value,
            proto.grpc.reflection.v1.ExtensionRequest
              .deserializeBinaryFromReader
          );
          msg.setFileContainingExtension(value);
          break;
        case 6:
          var value = /** @type {string} */ (reader.readString());
          msg.setAllExtensionNumbersOfType(value);
          break;
        case 7:
          var value = /** @type {string} */ (reader.readString());
          msg.setListServices(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.grpc.reflection.v1.ServerReflectionRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.reflection.v1.ServerReflectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.reflection.v1.ServerReflectionRequest.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getHost();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = /** @type {string} */ (Message.getField(message, 3));
    if (f != null) {
      writer.writeString(3, f);
    }
    f = /** @type {string} */ (Message.getField(message, 4));
    if (f != null) {
      writer.writeString(4, f);
    }
    f = message.getFileContainingExtension();
    if (f != null) {
      writer.writeMessage(
        5,
        f,
        proto.grpc.reflection.v1.ExtensionRequest.serializeBinaryToWriter
      );
    }
    f = /** @type {string} */ (Message.getField(message, 6));
    if (f != null) {
      writer.writeString(6, f);
    }
    f = /** @type {string} */ (Message.getField(message, 7));
    if (f != null) {
      writer.writeString(7, f);
    }
  };

/**
 * optional string host = 1;
 * @return {string}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.getHost =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.setHost = function (
  value
) {
  return Message.setProto3StringField(this, 1, value);
};

/**
 * optional string file_by_filename = 3;
 * @return {string}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.getFileByFilename =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 3, ""));
  };

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.setFileByFilename =
  function (value) {
    return Message.setOneofField(
      this,
      3,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.clearFileByFilename =
  function () {
    return Message.setOneofField(
      this,
      3,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      undefined
    );
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.hasFileByFilename =
  function () {
    return Message.getField(this, 3) != null;
  };

/**
 * optional string file_containing_symbol = 4;
 * @return {string}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.getFileContainingSymbol =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 4, ""));
  };

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.setFileContainingSymbol =
  function (value) {
    return Message.setOneofField(
      this,
      4,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.clearFileContainingSymbol =
  function () {
    return Message.setOneofField(
      this,
      4,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      undefined
    );
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.hasFileContainingSymbol =
  function () {
    return Message.getField(this, 4) != null;
  };

/**
 * optional ExtensionRequest file_containing_extension = 5;
 * @return {?proto.grpc.reflection.v1.ExtensionRequest}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.getFileContainingExtension =
  function () {
    return /** @type{?proto.grpc.reflection.v1.ExtensionRequest} */ (
      Message.getWrapperField(
        this,
        proto.grpc.reflection.v1.ExtensionRequest,
        5
      )
    );
  };

/**
 * @param {?proto.grpc.reflection.v1.ExtensionRequest|undefined} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.setFileContainingExtension =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      5,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.clearFileContainingExtension =
  function () {
    return this.setFileContainingExtension(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.hasFileContainingExtension =
  function () {
    return Message.getField(this, 5) != null;
  };

/**
 * optional string all_extension_numbers_of_type = 6;
 * @return {string}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.getAllExtensionNumbersOfType =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 6, ""));
  };

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.setAllExtensionNumbersOfType =
  function (value) {
    return Message.setOneofField(
      this,
      6,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.clearAllExtensionNumbersOfType =
  function () {
    return Message.setOneofField(
      this,
      6,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      undefined
    );
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.hasAllExtensionNumbersOfType =
  function () {
    return Message.getField(this, 6) != null;
  };

/**
 * optional string list_services = 7;
 * @return {string}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.getListServices =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 7, ""));
  };

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.setListServices =
  function (value) {
    return Message.setOneofField(
      this,
      7,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionRequest} returns this
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.clearListServices =
  function () {
    return Message.setOneofField(
      this,
      7,
      proto.grpc.reflection.v1.ServerReflectionRequest.oneofGroups_[0],
      undefined
    );
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionRequest.prototype.hasListServices =
  function () {
    return Message.getField(this, 7) != null;
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.grpc.reflection.v1.ExtensionRequest.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.grpc.reflection.v1.ExtensionRequest.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.grpc.reflection.v1.ExtensionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.grpc.reflection.v1.ExtensionRequest.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        containingType: Message.getFieldWithDefault(msg, 1, ""),
        extensionNumber: Message.getFieldWithDefault(msg, 2, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.reflection.v1.ExtensionRequest}
 */
proto.grpc.reflection.v1.ExtensionRequest.deserializeBinary = function (bytes) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.grpc.reflection.v1.ExtensionRequest();
  return proto.grpc.reflection.v1.ExtensionRequest.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.reflection.v1.ExtensionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.reflection.v1.ExtensionRequest}
 */
proto.grpc.reflection.v1.ExtensionRequest.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setContainingType(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setExtensionNumber(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.reflection.v1.ExtensionRequest.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.grpc.reflection.v1.ExtensionRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.reflection.v1.ExtensionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.reflection.v1.ExtensionRequest.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getContainingType();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getExtensionNumber();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};

/**
 * optional string containing_type = 1;
 * @return {string}
 */
proto.grpc.reflection.v1.ExtensionRequest.prototype.getContainingType =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ExtensionRequest} returns this
 */
proto.grpc.reflection.v1.ExtensionRequest.prototype.setContainingType =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * optional int32 extension_number = 2;
 * @return {number}
 */
proto.grpc.reflection.v1.ExtensionRequest.prototype.getExtensionNumber =
  function () {
    return /** @type {number} */ (Message.getFieldWithDefault(this, 2, 0));
  };

/**
 * @param {number} value
 * @return {!proto.grpc.reflection.v1.ExtensionRequest} returns this
 */
proto.grpc.reflection.v1.ExtensionRequest.prototype.setExtensionNumber =
  function (value) {
    return Message.setProto3IntField(this, 2, value);
  };

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.grpc.reflection.v1.ServerReflectionResponse.oneofGroups_ = [[4, 5, 6, 7]];

/**
 * @enum {number}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.MessageResponseCase = {
  MESSAGE_RESPONSE_NOT_SET: 0,
  FILE_DESCRIPTOR_RESPONSE: 4,
  ALL_EXTENSION_NUMBERS_RESPONSE: 5,
  LIST_SERVICES_RESPONSE: 6,
  ERROR_RESPONSE: 7,
};

/**
 * @return {proto.grpc.reflection.v1.ServerReflectionResponse.MessageResponseCase}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.getMessageResponseCase =
  function () {
    return /** @type {proto.grpc.reflection.v1.ServerReflectionResponse.MessageResponseCase} */ (
      Message.computeOneofCase(
        this,
        proto.grpc.reflection.v1.ServerReflectionResponse.oneofGroups_[0]
      )
    );
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.grpc.reflection.v1.ServerReflectionResponse.prototype.toObject =
    function (opt_includeInstance) {
      return proto.grpc.reflection.v1.ServerReflectionResponse.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.grpc.reflection.v1.ServerReflectionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.grpc.reflection.v1.ServerReflectionResponse.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        validHost: Message.getFieldWithDefault(msg, 1, ""),
        originalRequest:
          (f = msg.getOriginalRequest()) &&
          proto.grpc.reflection.v1.ServerReflectionRequest.toObject(
            includeInstance,
            f
          ),
        fileDescriptorResponse:
          (f = msg.getFileDescriptorResponse()) &&
          proto.grpc.reflection.v1.FileDescriptorResponse.toObject(
            includeInstance,
            f
          ),
        allExtensionNumbersResponse:
          (f = msg.getAllExtensionNumbersResponse()) &&
          proto.grpc.reflection.v1.ExtensionNumberResponse.toObject(
            includeInstance,
            f
          ),
        listServicesResponse:
          (f = msg.getListServicesResponse()) &&
          proto.grpc.reflection.v1.ListServiceResponse.toObject(
            includeInstance,
            f
          ),
        errorResponse:
          (f = msg.getErrorResponse()) &&
          proto.grpc.reflection.v1.ErrorResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.grpc.reflection.v1.ServerReflectionResponse();
  return proto.grpc.reflection.v1.ServerReflectionResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.reflection.v1.ServerReflectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setValidHost(value);
          break;
        case 2:
          var value = new proto.grpc.reflection.v1.ServerReflectionRequest();
          reader.readMessage(
            value,
            proto.grpc.reflection.v1.ServerReflectionRequest
              .deserializeBinaryFromReader
          );
          msg.setOriginalRequest(value);
          break;
        case 4:
          var value = new proto.grpc.reflection.v1.FileDescriptorResponse();
          reader.readMessage(
            value,
            proto.grpc.reflection.v1.FileDescriptorResponse
              .deserializeBinaryFromReader
          );
          msg.setFileDescriptorResponse(value);
          break;
        case 5:
          var value = new proto.grpc.reflection.v1.ExtensionNumberResponse();
          reader.readMessage(
            value,
            proto.grpc.reflection.v1.ExtensionNumberResponse
              .deserializeBinaryFromReader
          );
          msg.setAllExtensionNumbersResponse(value);
          break;
        case 6:
          var value = new proto.grpc.reflection.v1.ListServiceResponse();
          reader.readMessage(
            value,
            proto.grpc.reflection.v1.ListServiceResponse
              .deserializeBinaryFromReader
          );
          msg.setListServicesResponse(value);
          break;
        case 7:
          var value = new proto.grpc.reflection.v1.ErrorResponse();
          reader.readMessage(
            value,
            proto.grpc.reflection.v1.ErrorResponse.deserializeBinaryFromReader
          );
          msg.setErrorResponse(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.grpc.reflection.v1.ServerReflectionResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.reflection.v1.ServerReflectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.reflection.v1.ServerReflectionResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getValidHost();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getOriginalRequest();
    if (f != null) {
      writer.writeMessage(
        2,
        f,
        proto.grpc.reflection.v1.ServerReflectionRequest.serializeBinaryToWriter
      );
    }
    f = message.getFileDescriptorResponse();
    if (f != null) {
      writer.writeMessage(
        4,
        f,
        proto.grpc.reflection.v1.FileDescriptorResponse.serializeBinaryToWriter
      );
    }
    f = message.getAllExtensionNumbersResponse();
    if (f != null) {
      writer.writeMessage(
        5,
        f,
        proto.grpc.reflection.v1.ExtensionNumberResponse.serializeBinaryToWriter
      );
    }
    f = message.getListServicesResponse();
    if (f != null) {
      writer.writeMessage(
        6,
        f,
        proto.grpc.reflection.v1.ListServiceResponse.serializeBinaryToWriter
      );
    }
    f = message.getErrorResponse();
    if (f != null) {
      writer.writeMessage(
        7,
        f,
        proto.grpc.reflection.v1.ErrorResponse.serializeBinaryToWriter
      );
    }
  };

/**
 * optional string valid_host = 1;
 * @return {string}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.getValidHost =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.setValidHost =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * optional ServerReflectionRequest original_request = 2;
 * @return {?proto.grpc.reflection.v1.ServerReflectionRequest}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.getOriginalRequest =
  function () {
    return /** @type{?proto.grpc.reflection.v1.ServerReflectionRequest} */ (
      Message.getWrapperField(
        this,
        proto.grpc.reflection.v1.ServerReflectionRequest,
        2
      )
    );
  };

/**
 * @param {?proto.grpc.reflection.v1.ServerReflectionRequest|undefined} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.setOriginalRequest =
  function (value) {
    return Message.setWrapperField(this, 2, value);
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.clearOriginalRequest =
  function () {
    return this.setOriginalRequest(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.hasOriginalRequest =
  function () {
    return Message.getField(this, 2) != null;
  };

/**
 * optional FileDescriptorResponse file_descriptor_response = 4;
 * @return {?proto.grpc.reflection.v1.FileDescriptorResponse}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.getFileDescriptorResponse =
  function () {
    return /** @type{?proto.grpc.reflection.v1.FileDescriptorResponse} */ (
      Message.getWrapperField(
        this,
        proto.grpc.reflection.v1.FileDescriptorResponse,
        4
      )
    );
  };

/**
 * @param {?proto.grpc.reflection.v1.FileDescriptorResponse|undefined} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.setFileDescriptorResponse =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      4,
      proto.grpc.reflection.v1.ServerReflectionResponse.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.clearFileDescriptorResponse =
  function () {
    return this.setFileDescriptorResponse(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.hasFileDescriptorResponse =
  function () {
    return Message.getField(this, 4) != null;
  };

/**
 * optional ExtensionNumberResponse all_extension_numbers_response = 5;
 * @return {?proto.grpc.reflection.v1.ExtensionNumberResponse}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.getAllExtensionNumbersResponse =
  function () {
    return /** @type{?proto.grpc.reflection.v1.ExtensionNumberResponse} */ (
      Message.getWrapperField(
        this,
        proto.grpc.reflection.v1.ExtensionNumberResponse,
        5
      )
    );
  };

/**
 * @param {?proto.grpc.reflection.v1.ExtensionNumberResponse|undefined} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.setAllExtensionNumbersResponse =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      5,
      proto.grpc.reflection.v1.ServerReflectionResponse.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.clearAllExtensionNumbersResponse =
  function () {
    return this.setAllExtensionNumbersResponse(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.hasAllExtensionNumbersResponse =
  function () {
    return Message.getField(this, 5) != null;
  };

/**
 * optional ListServiceResponse list_services_response = 6;
 * @return {?proto.grpc.reflection.v1.ListServiceResponse}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.getListServicesResponse =
  function () {
    return /** @type{?proto.grpc.reflection.v1.ListServiceResponse} */ (
      Message.getWrapperField(
        this,
        proto.grpc.reflection.v1.ListServiceResponse,
        6
      )
    );
  };

/**
 * @param {?proto.grpc.reflection.v1.ListServiceResponse|undefined} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.setListServicesResponse =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      6,
      proto.grpc.reflection.v1.ServerReflectionResponse.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.clearListServicesResponse =
  function () {
    return this.setListServicesResponse(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.hasListServicesResponse =
  function () {
    return Message.getField(this, 6) != null;
  };

/**
 * optional ErrorResponse error_response = 7;
 * @return {?proto.grpc.reflection.v1.ErrorResponse}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.getErrorResponse =
  function () {
    return /** @type{?proto.grpc.reflection.v1.ErrorResponse} */ (
      Message.getWrapperField(this, proto.grpc.reflection.v1.ErrorResponse, 7)
    );
  };

/**
 * @param {?proto.grpc.reflection.v1.ErrorResponse|undefined} value
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.setErrorResponse =
  function (value) {
    return Message.setOneofWrapperField(
      this,
      7,
      proto.grpc.reflection.v1.ServerReflectionResponse.oneofGroups_[0],
      value
    );
  };

/**
 * Clears the message field making it undefined.
 * @return {!proto.grpc.reflection.v1.ServerReflectionResponse} returns this
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.clearErrorResponse =
  function () {
    return this.setErrorResponse(undefined);
  };

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.grpc.reflection.v1.ServerReflectionResponse.prototype.hasErrorResponse =
  function () {
    return Message.getField(this, 7) != null;
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.grpc.reflection.v1.FileDescriptorResponse.repeatedFields_ = [1];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.grpc.reflection.v1.FileDescriptorResponse.prototype.toObject =
    function (opt_includeInstance) {
      return proto.grpc.reflection.v1.FileDescriptorResponse.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.grpc.reflection.v1.FileDescriptorResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.grpc.reflection.v1.FileDescriptorResponse.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        fileDescriptorProtoList: msg.getFileDescriptorProtoList_asB64(),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.reflection.v1.FileDescriptorResponse}
 */
proto.grpc.reflection.v1.FileDescriptorResponse.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.grpc.reflection.v1.FileDescriptorResponse();
  return proto.grpc.reflection.v1.FileDescriptorResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.reflection.v1.FileDescriptorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.reflection.v1.FileDescriptorResponse}
 */
proto.grpc.reflection.v1.FileDescriptorResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.addFileDescriptorProto(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.reflection.v1.FileDescriptorResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.grpc.reflection.v1.FileDescriptorResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.reflection.v1.FileDescriptorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.reflection.v1.FileDescriptorResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getFileDescriptorProtoList_asU8();
    if (f.length > 0) {
      writer.writeRepeatedBytes(1, f);
    }
  };

/**
 * repeated bytes file_descriptor_proto = 1;
 * @return {!Array<string>}
 */
proto.grpc.reflection.v1.FileDescriptorResponse.prototype.getFileDescriptorProtoList =
  function () {
    return /** @type {!Array<string>} */ (Message.getRepeatedField(this, 1));
  };

/**
 * repeated bytes file_descriptor_proto = 1;
 * This is a type-conversion wrapper around `getFileDescriptorProtoList()`
 * @return {!Array<string>}
 */
proto.grpc.reflection.v1.FileDescriptorResponse.prototype.getFileDescriptorProtoList_asB64 =
  function () {
    return /** @type {!Array<string>} */ (
      Message.bytesListAsB64(this.getFileDescriptorProtoList())
    );
  };

/**
 * repeated bytes file_descriptor_proto = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileDescriptorProtoList()`
 * @return {!Array<!Uint8Array>}
 */
proto.grpc.reflection.v1.FileDescriptorResponse.prototype.getFileDescriptorProtoList_asU8 =
  function () {
    return /** @type {!Array<!Uint8Array>} */ (
      Message.bytesListAsU8(this.getFileDescriptorProtoList())
    );
  };

/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.grpc.reflection.v1.FileDescriptorResponse} returns this
 */
proto.grpc.reflection.v1.FileDescriptorResponse.prototype.setFileDescriptorProtoList =
  function (value) {
    return Message.setField(this, 1, value || []);
  };

/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.grpc.reflection.v1.FileDescriptorResponse} returns this
 */
proto.grpc.reflection.v1.FileDescriptorResponse.prototype.addFileDescriptorProto =
  function (value, opt_index) {
    return Message.addToRepeatedField(this, 1, value, opt_index);
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.grpc.reflection.v1.FileDescriptorResponse} returns this
 */
proto.grpc.reflection.v1.FileDescriptorResponse.prototype.clearFileDescriptorProtoList =
  function () {
    return this.setFileDescriptorProtoList([]);
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.repeatedFields_ = [2];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.grpc.reflection.v1.ExtensionNumberResponse.prototype.toObject =
    function (opt_includeInstance) {
      return proto.grpc.reflection.v1.ExtensionNumberResponse.toObject(
        opt_includeInstance,
        this
      );
    };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.grpc.reflection.v1.ExtensionNumberResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.grpc.reflection.v1.ExtensionNumberResponse.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        baseTypeName: Message.getFieldWithDefault(msg, 1, ""),
        extensionNumberList:
          (f = Message.getRepeatedField(msg, 2)) == null ? undefined : f,
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.reflection.v1.ExtensionNumberResponse}
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.grpc.reflection.v1.ExtensionNumberResponse();
  return proto.grpc.reflection.v1.ExtensionNumberResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.reflection.v1.ExtensionNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.reflection.v1.ExtensionNumberResponse}
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setBaseTypeName(value);
          break;
        case 2:
          var values = /** @type {!Array<number>} */ (
            reader.isDelimited()
              ? reader.readPackedInt32()
              : [reader.readInt32()]
          );
          for (var i = 0; i < values.length; i++) {
            msg.addExtensionNumber(values[i]);
          }
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.grpc.reflection.v1.ExtensionNumberResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.reflection.v1.ExtensionNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getBaseTypeName();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message.getExtensionNumberList();
    if (f.length > 0) {
      writer.writePackedInt32(2, f);
    }
  };

/**
 * optional string base_type_name = 1;
 * @return {string}
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.prototype.getBaseTypeName =
  function () {
    return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
  };

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ExtensionNumberResponse} returns this
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.prototype.setBaseTypeName =
  function (value) {
    return Message.setProto3StringField(this, 1, value);
  };

/**
 * repeated int32 extension_number = 2;
 * @return {!Array<number>}
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.prototype.getExtensionNumberList =
  function () {
    return /** @type {!Array<number>} */ (Message.getRepeatedField(this, 2));
  };

/**
 * @param {!Array<number>} value
 * @return {!proto.grpc.reflection.v1.ExtensionNumberResponse} returns this
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.prototype.setExtensionNumberList =
  function (value) {
    return Message.setField(this, 2, value || []);
  };

/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.grpc.reflection.v1.ExtensionNumberResponse} returns this
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.prototype.addExtensionNumber =
  function (value, opt_index) {
    return Message.addToRepeatedField(this, 2, value, opt_index);
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.grpc.reflection.v1.ExtensionNumberResponse} returns this
 */
proto.grpc.reflection.v1.ExtensionNumberResponse.prototype.clearExtensionNumberList =
  function () {
    return this.setExtensionNumberList([]);
  };

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.grpc.reflection.v1.ListServiceResponse.repeatedFields_ = [1];

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.grpc.reflection.v1.ListServiceResponse.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.grpc.reflection.v1.ListServiceResponse.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.grpc.reflection.v1.ListServiceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.grpc.reflection.v1.ListServiceResponse.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        serviceList: Message.toObjectList(
          msg.getServiceList(),
          proto.grpc.reflection.v1.ServiceResponse.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.reflection.v1.ListServiceResponse}
 */
proto.grpc.reflection.v1.ListServiceResponse.deserializeBinary = function (
  bytes
) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.grpc.reflection.v1.ListServiceResponse();
  return proto.grpc.reflection.v1.ListServiceResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.reflection.v1.ListServiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.reflection.v1.ListServiceResponse}
 */
proto.grpc.reflection.v1.ListServiceResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.grpc.reflection.v1.ServiceResponse();
          reader.readMessage(
            value,
            proto.grpc.reflection.v1.ServiceResponse.deserializeBinaryFromReader
          );
          msg.addService(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.reflection.v1.ListServiceResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.grpc.reflection.v1.ListServiceResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.reflection.v1.ListServiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.reflection.v1.ListServiceResponse.serializeBinaryToWriter =
  function (message, writer) {
    var f = undefined;
    f = message.getServiceList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(
        1,
        f,
        proto.grpc.reflection.v1.ServiceResponse.serializeBinaryToWriter
      );
    }
  };

/**
 * repeated ServiceResponse service = 1;
 * @return {!Array<!proto.grpc.reflection.v1.ServiceResponse>}
 */
proto.grpc.reflection.v1.ListServiceResponse.prototype.getServiceList =
  function () {
    return /** @type{!Array<!proto.grpc.reflection.v1.ServiceResponse>} */ (
      Message.getRepeatedWrapperField(
        this,
        proto.grpc.reflection.v1.ServiceResponse,
        1
      )
    );
  };

/**
 * @param {!Array<!proto.grpc.reflection.v1.ServiceResponse>} value
 * @return {!proto.grpc.reflection.v1.ListServiceResponse} returns this
 */
proto.grpc.reflection.v1.ListServiceResponse.prototype.setServiceList =
  function (value) {
    return Message.setRepeatedWrapperField(this, 1, value);
  };

/**
 * @param {!proto.grpc.reflection.v1.ServiceResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.grpc.reflection.v1.ServiceResponse}
 */
proto.grpc.reflection.v1.ListServiceResponse.prototype.addService = function (
  opt_value,
  opt_index
) {
  return Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.grpc.reflection.v1.ServiceResponse,
    opt_index
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.grpc.reflection.v1.ListServiceResponse} returns this
 */
proto.grpc.reflection.v1.ListServiceResponse.prototype.clearServiceList =
  function () {
    return this.setServiceList([]);
  };

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.grpc.reflection.v1.ServiceResponse.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.grpc.reflection.v1.ServiceResponse.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.grpc.reflection.v1.ServiceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.grpc.reflection.v1.ServiceResponse.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        name: Message.getFieldWithDefault(msg, 1, ""),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.reflection.v1.ServiceResponse}
 */
proto.grpc.reflection.v1.ServiceResponse.deserializeBinary = function (bytes) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.grpc.reflection.v1.ServiceResponse();
  return proto.grpc.reflection.v1.ServiceResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.reflection.v1.ServiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.reflection.v1.ServiceResponse}
 */
proto.grpc.reflection.v1.ServiceResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.reflection.v1.ServiceResponse.prototype.serializeBinary =
  function () {
    var writer = new BinaryWriter();
    proto.grpc.reflection.v1.ServiceResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.reflection.v1.ServiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.reflection.v1.ServiceResponse.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.grpc.reflection.v1.ServiceResponse.prototype.getName = function () {
  return /** @type {string} */ (Message.getFieldWithDefault(this, 1, ""));
};

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ServiceResponse} returns this
 */
proto.grpc.reflection.v1.ServiceResponse.prototype.setName = function (value) {
  return Message.setProto3StringField(this, 1, value);
};

if (Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.grpc.reflection.v1.ErrorResponse.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.grpc.reflection.v1.ErrorResponse.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.grpc.reflection.v1.ErrorResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.grpc.reflection.v1.ErrorResponse.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        errorCode: Message.getFieldWithDefault(msg, 1, 0),
        errorMessage: Message.getFieldWithDefault(msg, 2, ""),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.grpc.reflection.v1.ErrorResponse}
 */
proto.grpc.reflection.v1.ErrorResponse.deserializeBinary = function (bytes) {
  var reader = new BinaryReader(bytes);
  var msg = new proto.grpc.reflection.v1.ErrorResponse();
  return proto.grpc.reflection.v1.ErrorResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.grpc.reflection.v1.ErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.grpc.reflection.v1.ErrorResponse}
 */
proto.grpc.reflection.v1.ErrorResponse.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setErrorCode(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setErrorMessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.grpc.reflection.v1.ErrorResponse.prototype.serializeBinary = function () {
  var writer = new BinaryWriter();
  proto.grpc.reflection.v1.ErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.grpc.reflection.v1.ErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.grpc.reflection.v1.ErrorResponse.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getErrorCode();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * optional int32 error_code = 1;
 * @return {number}
 */
proto.grpc.reflection.v1.ErrorResponse.prototype.getErrorCode = function () {
  return /** @type {number} */ (Message.getFieldWithDefault(this, 1, 0));
};

/**
 * @param {number} value
 * @return {!proto.grpc.reflection.v1.ErrorResponse} returns this
 */
proto.grpc.reflection.v1.ErrorResponse.prototype.setErrorCode = function (
  value
) {
  return Message.setProto3IntField(this, 1, value);
};

/**
 * optional string error_message = 2;
 * @return {string}
 */
proto.grpc.reflection.v1.ErrorResponse.prototype.getErrorMessage = function () {
  return /** @type {string} */ (Message.getFieldWithDefault(this, 2, ""));
};

/**
 * @param {string} value
 * @return {!proto.grpc.reflection.v1.ErrorResponse} returns this
 */
proto.grpc.reflection.v1.ErrorResponse.prototype.setErrorMessage = function (
  value
) {
  return Message.setProto3StringField(this, 2, value);
};

goog.object.extend(exports, proto.grpc.reflection.v1);
